import { useFormContext } from 'react-hook-form';

export const useSpreedlyGlobalErrors = () => {
  const {
    formState: { errors },
  } = useFormContext();

  // handleErrors/handleCheckoutSdkErrors call form.setError(`global.${index}`,
  // {...}) for each attribute-less error in a batch — keyed by the error's
  // position, never by its own `key` (which can contain dots, e.g. Spreedly's
  // "errors.invalid_environment_key_parameter", and would make react-hook-form
  // nest one level deeper than expected). Keying by index also means several
  // attribute-less errors from one batch each get their own slot instead of
  // one setError call overwriting another. So Object.values(errors.global)
  // gives the error object(s) themselves (each still has .message) — drilling
  // one level further (as this used to) instead reads the *values* of a
  // single error object's own properties (type/key/message/ref), the last of
  // which (react-hook-form's own `ref`) is always undefined and crashes
  // FormError's error.message read below.
  return Object.values(errors.global ?? {});
};
